import React from 'react'
import './App.css';
import Nav from './components/Nav'
import Head_Img from './components/Head_Img'
import Services from './components/Services'
import Products from './components/Products'
import Footer from './components/Footer'

const App = () => {

    return (
    <>
      <Nav />
      <Head_Img />
      <Products />
      <Services />
      <Footer />
      </>
    )
  
}

export default App;